import React from 'react';
import { Modal } from 'reactstrap';
import i18next from 'i18next';
import { Tablet } from 'react-feather';

import CollapsibleCard from '../common/CollapsibleCard';

import enterPageImg from '../../../assets/images/getting-started/1-notification-permission/1-enter-page.png';
import loginImg from '../../../assets/images/getting-started/1-notification-permission/2-login.png';
import acceptNotificationsImg from '../../../assets/images/getting-started/1-notification-permission/3-accept-notification.png';
import savePassClickOkImg from '../../../assets/images/getting-started/1-notification-permission/4-save-pass-click-ok.png';

import openSettingsImg from '../../../assets/images/getting-started/2-ensure-notification-priority/5-open-settings.png';
import findNotificationsImg from '../../../assets/images/getting-started/2-ensure-notification-priority/6-find-notifications.png';
import findAdminOtoStolik from '../../../assets/images/getting-started/2-ensure-notification-priority/7-find-admin-otostolik.png';
import ensureImportantImg from '../../../assets/images/getting-started/2-ensure-notification-priority/8-ensure-important.png';

import addToHomeScreenImg from '../../../assets/images/getting-started/3-add-to-home-screen/9-add-to-home-screen.png';
import presentIconOnHomeScreenImg from '../../../assets/images/getting-started/3-add-to-home-screen/13-present.png';

import './GetDeviceReady.scss';

const fullScreenModalStyle = {
  height: 'calc(100% - 80px)',
  margin: 40,
  maxWidth: 'none',
  width: 'calc(100% - 80px)',
};

const getPart1Items = () => [
  {
    src: enterPageImg,
    altText: i18next.t('get-device-ready.part1-1-alt'),
    caption: (
      <div>
        {i18next.t('get-device-ready.part1-1-caption-prefix')}{' '}
        <a href="https://admin.otostolik.pl">https://admin.otostolik.pl</a>
      </div>
    ),
    header: '1.1',
    key: '1',
  },
  {
    src: loginImg,
    altText: i18next.t('get-device-ready.part1-2-alt'),
    caption: <div>{i18next.t('get-device-ready.part1-2-caption')}</div>,
    header: '1.2',
    key: '2',
  },
  {
    src: acceptNotificationsImg,
    caption: i18next.t('get-device-ready.part1-3-caption'),
    key: '3',
  },
  {
    src: savePassClickOkImg,
    caption: i18next.t('get-device-ready.part1-4-caption'),
    key: '4',
  },
];

const getPart2Items = () => [
  {
    src: openSettingsImg,
    caption: i18next.t('get-device-ready.part2-1-caption'),
    key: '1',
  },
  {
    src: findNotificationsImg,
    caption: i18next.t('get-device-ready.part2-2-caption'),
    key: '2',
  },
  {
    src: findAdminOtoStolik,
    caption: i18next.t('get-device-ready.part2-3-caption'),
    key: '3',
  },
  {
    src: ensureImportantImg,
    caption: (
      <>
        {i18next.t('get-device-ready.part2-4-caption-prefix')} <strong>{i18next.t('get-device-ready.part2-4-caption-importance')}</strong> {i18next.t('get-device-ready.part2-4-caption-suffix')}
      </>
    ),
    key: '4',
  },
];

const getPart3Items = () => [
  {
    src: addToHomeScreenImg,
    caption: (
      <>
        {i18next.t('get-device-ready.part3-1-caption-prefix')}{' '}
        <strong>{i18next.t('get-device-ready.part3-1-caption-action')}</strong>. {i18next.t('get-device-ready.part3-1-caption-suffix')}
      </>
    ),
    key: '1',
  },
  {
    src: presentIconOnHomeScreenImg,
    caption: (
      <>
        {i18next.t('get-device-ready.part3-2-caption-prefix')} <div className="text-danger">{i18next.t('get-device-ready.part3-2-caption-warning')}</div> {i18next.t('get-device-ready.part3-2-caption-suffix')}
      </>
    ),
    key: '2',
  },
];

type GetDeviceReadyState = {
  openImage: string | null;
}

class GetDeviceReady extends React.PureComponent<
  {},
  GetDeviceReadyState
> {
  state: GetDeviceReadyState = { openImage: null };

  openImageModal = (e) => this.setState({ openImage: e.target.src });
  hideModal = () => this.setState({ openImage: null });

  render() {
    return (
      <>
        <CollapsibleCard
          title={
            <>
              <Tablet />{' '}
              <span>
                {i18next.t('get-device-ready.title')}
              </span>
            </>
          }
        >
          <h3 className="mb-3 font-weight-bold">
            {i18next.t('get-device-ready.part1-title')}
          </h3>
          <div className="image-tutorial-container">
            {getPart1Items().map(this.renderItem)}
            <h3 className="bt-1 pt-2 mb-3 font-weight-bold">
              {i18next.t('get-device-ready.part2-title')}
            </h3>
            {getPart2Items().map(this.renderItem)}
            <h3 className="bt-1 pt-2 mb-3 font-weight-bold">
              {i18next.t('get-device-ready.part3-title')}
            </h3>
            {getPart3Items().map(this.renderItem)}
          </div>
        </CollapsibleCard>
        <Modal
          isOpen={!!this.state.openImage}
          toggle={this.hideModal}
          style={fullScreenModalStyle}
        >
          {this.state.openImage && (
            <img
              src={this.state.openImage}
              alt="full screen"
              onClick={this.hideModal}
            />
          )}
        </Modal>
      </>
    );
  }

  renderItem = (item) => (
    <figure key={item.key}>
      <img src={item.src} alt={item.alt} onClick={this.openImageModal} />
      <figcaption>{item.caption}</figcaption>
    </figure>
  );
}

export default GetDeviceReady;
